export default function item(enumerable, index) {
    let count = 0;
    for (const item of enumerable) {
        if (count <= index && count === index) {
            return item;
        }
        count++;
    }
}
